import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const HealthcareIT = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Healthcare IT" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-domains',
                            'text':'Business Domains'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Healthcare IT</h2>
                        <p>We build our solutions around your practice. Our solutions would cover every aspect of your practice, be it diagnostics, patient care, or administration. Unify all roles of your practise to improve clinical care</p>
                        <h3>Solutions For Every Step</h3>
                        <p>Be it healthcare delivery, diagnosing with precision, tracking patient health records, data management, communication glitches we have solutions for every step of patient journey.</p>
                        <h3>Go Straight To Smart</h3>
                        <p>Our team of experienced subject matter experts and healthcare technofunctional architects will help your organization manage its health information systems through advisory services, and strategic solutions.</p>
                        <h3>Automation Is Game Changer</h3>
                        <p>Our IT solutions are core resources for both health care organisation and professionals to aid decision making to deliver utmost quality.</p>
                        <h3>Who Can Benefit</h3>
                        <ul>
                            <li>Hospitals & Medical Institutions</li>
                            <li>Clinics</li>
                            <li>Diagnostics</li>
                            <li>Physicians</li>
                            <li>Pharmacy</li>
                            <li>Healthcare Aggregators</li>
                        </ul>
                        <h3>Solutions That Reasonate With Clinical Context</h3>
                        <h3>ERP</h3>
                        <p>Tailor made, robust and customised that aligns well in line with clinical practices. One shared database that provides your organization with a clear line of sight across all departments.</p>
                        <h3>Telemedicine/Virtual Health</h3>
                        <p>We at Krisantec focus on developing virtual health care solutions i.e., video consultations, secured clinical documentation & sharing, booking and all kinds of clinical coordination services through a unified platform that can function solely or in integration with the existing healthcare solutions.</p>
                        <h3>EMR</h3>
                        <p>Our EMR solution will help you with Speciality Templates and custom templates to practice the EMR to store your patients’ health records digitally in a systematic way and to populate electronically whenever it is needed as per the EMR and EHR standards of India with features of data encryptions and security.</p>
                        <h3>CRM</h3>
                        <p>Involve patients in their own healthcare and manage your entire operations seamlessly. Discover trends among patients, uncover opportunities for enhanced treatments, improve patient acquisition and expand your practice.</p>
                        <h3>HIMS</h3>
                        <p>Speed up your smart hospital journey. This scalable solution grows with you. Streamline your operations, minimize cost and enhances your patient experience with Krisantec HIMS.</p>
                        <h3>CMS</h3>
                        <p>No more forgotten files and records. Make your practice paperless. Be it individual or multi center clinics we make sure our clinic management system is customized to your workflows.</p>
                        <p>Well organised and smartly designed. Make administration easier than ever. Automate your front desk, reduce redundant task like create billings during scheduling.</p>
                        <h3>Make It Significant</h3>
                        <ul>
                            <li>Highly Scalable</li>
                            <li>Flexible Architecture</li>
                            <li>Seamless Data Integration</li>
                            <li>HIPAA Compliant</li>
                        </ul>
                        <h3>Benefits</h3>
                        <ul>
                            <li>Clinical Decision Support</li>
                            <li>Enhance Patient Care</li>
                            <li>Real Time Information Exchange</li>
                            <li>Data Analytics</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default HealthcareIT;